import $ from 'jquery';
// JS
/*import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';*/

import Swiper from 'swiper/bundle';
// import Swiper styles
import 'swiper/css';

window.$ = $;

// fancybox($);

$(document).ready(function() {


    $('nav.main li.menu').click(function(e) {
        e.preventDefault();
        $('header.main').toggleClass('open');
    });

    $('nav.main li.close').click(function(e) {
        e.preventDefault();
        $('header.main').toggleClass('open');
    });

});

$(document).ready(function () {
    const element = $(".roses"); // Ersetze "#deinElement" mit deinem Element-Selektor
    element.css("opacity", 0); // Setzt die Anfangs-Opacity auf 0

    $(window).on("scroll", function () {
        const scrollTop = $(this).scrollTop(); // Wie weit der Nutzer gescrollt hat
        const documentHeight = $(document).height(); // Gesamthöhe der Seite
        const windowHeight = $(this).height(); // Höhe des sichtbaren Fensters
        const maxScroll = documentHeight - windowHeight; // Maximale Scrollhöhe

        // Berechnung der Opacity basierend auf dem Scroll
        const newOpacity = Math.min(0.2, scrollTop / maxScroll); // Begrenzung auf 0.4
        element.css("opacity", newOpacity); // Anwenden der berechneten Opacity

    });
});

// mode fade
var swiper = new Swiper('.homeswiper', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 30,
    effect: "fade",
    autoplay: true,
    speed: 2000,

    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
});

// swiper
var swiper = new Swiper('.referenzenswiper', {
    slidesPerView: 1,
    loop: false,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
        dynamicBullets: true,
    },
});


